import { useNavigate } from "react-router-dom";
import { useEffect } from "react";
import { setSEO } from "../utils/seo";


const inputStyle = {
  width: "100%",
  padding: "12px",
  marginBottom: "12px",
  borderRadius: "6px",
  border: "none",
  color: "#0b1d2a",
  backgroundColor: "#ffffff",
};

const GetApproved = () => {
  useEffect(() => {
  setSEO({
    title: "Get Approved for Car Financing in Canada | YesAuto",
    description:
      "Check your car financing approval instantly with YesAuto. Bad credit, new credit, or no credit. Start with a quick application.",
  });
}, []);

  const navigate = useNavigate();

  const handleScroll = () => {
    const formSection = document.getElementById("lead-form");
    if (formSection) {
      formSection.scrollIntoView({ behavior: "smooth" });
    }
  };

  return (
    <>
      {/* ================= HERO SECTION ================= */}
      <div
        style={{
          minHeight: "100vh",
          backgroundColor: "#0b1d2a",
          color: "#ffffff",
          padding: "60px 24px",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <div style={{ width: "100%", maxWidth: "1100px" }}>
          <h1 style={{ fontSize: "42px", marginBottom: "16px" }}>
            Get Approved for Auto Financing in Canada
          </h1>

          <p
            style={{
              fontSize: "18px",
              maxWidth: "420px",
              opacity: 0.85,
              marginBottom: "32px",
            }}
          >
            Fast, secure auto financing for all credit types.
            Start with a quick application — no obligation.
          </p>

          <button
            onClick={handleScroll}
            style={{
              padding: "16px 32px",
              fontSize: "18px",
              backgroundColor: "#14b8a6",
              color: "#0b1d2a",
              border: "none",
              borderRadius: "10px",
              cursor: "pointer",
              fontWeight: "600",
            }}
          >
            Start My Application
          </button>
        </div>
      </div>

      {/* ================= FORM SECTION (BOTTOM) ================= */}
      <div
        id="lead-form"
        style={{
          backgroundColor: "#0b1d2a",
          padding: "80px 24px",
          display: "flex",
          justifyContent: "center",
        }}
      >
        <div
          style={{
            width: "100%",
            maxWidth: "420px",
            display: "flex",
            flexDirection: "column",
            gap: "20px",
          }}
        >
          {/* TRUST BOX */}
          <div
            style={{
              backgroundColor: "#0f2a3d",
              padding: "24px",
              borderRadius: "14px",
              color: "#ffffff",
              fontSize: "15px",
              lineHeight: "1.6",
            }}
          >
            ✓ No impact on your credit score<br />
            ✓ Secure & confidential application<br />
            ✓ All credit types welcome
          </div>

          {/* FORM CARD */}
          <form
            onSubmit={(e) => {
              e.preventDefault();
              navigate("/apply");
            }}
            style={{
              backgroundColor: "#0f2a3d",
              padding: "28px",
              borderRadius: "14px",
            }}
          >
            <h3 style={{ marginBottom: "16px", fontSize: "20px", color: "#fff" }}>
              Quick Application
            </h3>

            <input
              type="text"
              placeholder="Full Name"
              required
              style={inputStyle}
            />

            <input
              type="tel"
              placeholder="Phone Number"
              required
              style={inputStyle}
            />

            <input
              type="email"
              placeholder="Email Address"
              required
              style={inputStyle}
            />

            <select required style={inputStyle}>
              <option value="">Select Credit Range</option>
              <option>Excellent</option>
              <option>Good</option>
              <option>Fair</option>
              <option>Poor</option>
              <option>No Credit</option>
            </select>

            <button
              type="submit"
              style={{
                width: "100%",
                padding: "14px",
                marginTop: "12px",
                backgroundColor: "#14b8a6",
                color: "#0b1d2a",
                border: "none",
                borderRadius: "10px",
                fontWeight: "600",
                cursor: "pointer",
                fontSize: "16px",
              }}
            >
              Continue Application
            </button>
            <p
  style={{
    marginTop: "12px",
    fontSize: "12px",
    opacity: 0.7,
    textAlign: "center",
    color: "#ffffff",
  }}
>
  By continuing, you agree to be contacted regarding your auto financing
  application. No purchase required.
</p>

          </form>
        </div>
      </div>
    </>
  );
};

export default GetApproved;
